import { City, Currency } from "../types";
import { httpClient } from "./httpClient";

export const getFuzzyCitiesSearchList = async (
  input: string
): Promise<City[]> =>
  (await httpClient.get<City[]>(`location/cities?startsWith=${input}`)).data;

export const getCityById = async (id: number): Promise<City> =>
  (await httpClient.get<City>(`location/city?id=${id}`)).data;

export const getCurrenciesByMarketId = async (
  marketId: number
): Promise<Currency[]> =>
  (await httpClient.get<Currency[]>(`location/currencies?marketId=${marketId}`))
    .data;
